import { render, staticRenderFns } from "./SDCardLanguage.vue?vue&type=template&id=6b786ce7&scoped=true&"
import script from "./SDCardLanguage.vue?vue&type=script&lang=js&"
export * from "./SDCardLanguage.vue?vue&type=script&lang=js&"
import style0 from "./SDCardLanguage.vue?vue&type=style&index=0&id=6b786ce7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b786ce7",
  null
  
)

export default component.exports